import classNames from 'classnames/bind';

import { IconButton } from 'components/IconButton/IconButtonDeprecated';

import { ROICanvasType } from '../types';
import { ROITooltip } from './Tooltip';

import styles from './Toolbar.module.scss';

const c = classNames.bind(styles);

type ROIToolbarProps = {
  type: ROICanvasType;
  isFullscreen: boolean;
  isShowingLabels: boolean;
  isDrawing: boolean;
  selectedShape: string | null;
  onCancel: () => void;
  onDeleteSelectedShape: () => void;
  onInsertEightPointRectangle: () => void;
  onInsertThreePointLine: () => void;
  onToggleFullscreen: () => void;
  onToggleLabels: () => void;
};

export function ROIToolbar({
  type,
  isFullscreen,
  isShowingLabels,
  isDrawing,
  selectedShape,
  onCancel,
  onDeleteSelectedShape,
  onInsertEightPointRectangle,
  onInsertThreePointLine,
  onToggleFullscreen,
  onToggleLabels,
}: ROIToolbarProps) {
  let typeLabel: string = type || 'shape';

  if (type === 'multiline') {
    typeLabel = 'line';
  } else if (type === 'polygon') {
    typeLabel = 'region';
  }

  return (
    <div className={c('toolbar')}>
      {type === 'multiline' && (
        <IconButton
          icon="vector-line"
          label={`Add ${typeLabel}`}
          onClick={onInsertThreePointLine}
          variant="tertiary"
          size="small"
          showLabel
        />
      )}

      {type === 'polygon' && (
        <IconButton
          icon="vector-square"
          label={`Add ${typeLabel}`}
          onClick={onInsertEightPointRectangle}
          variant="tertiary"
          size="small"
          showLabel
        />
      )}

      {(isDrawing || selectedShape !== null) && (
        <IconButton
          icon="cancel"
          label={`Cancel ${typeLabel} edit`}
          onClick={onCancel}
          variant="tertiary"
          size="small"
          showLabel
        />
      )}

      <IconButton
        icon="delete"
        label={`Delete ${selectedShape}`}
        onClick={onDeleteSelectedShape}
        variant={selectedShape === null ? 'tertiary' : 'primary'}
        intent="danger"
        size="small"
        disabled={selectedShape === null}
        disabledTooltip="Please select a shape"
        showLabel={selectedShape !== null}
      />

      <div>
        <IconButton
          icon={isShowingLabels ? 'eye-off' : 'eye'}
          label={isShowingLabels ? 'Hide labels' : 'Show labels'}
          onClick={onToggleLabels}
          variant="tertiary"
          size="small"
        />

        <IconButton
          icon={isFullscreen ? 'collapse' : 'expand'}
          label="Toggle fullscreen"
          onClick={onToggleFullscreen}
          variant="tertiary"
          size="small"
        />

        <ROITooltip typeLabel={typeLabel} />
      </div>
    </div>
  );
}
